import { render, staticRenderFns } from "./BandejaExpedientes.vue?vue&type=template&id=d760e0ba&scoped=true"
import script from "./BandejaExpedientes.vue?vue&type=script&lang=js"
export * from "./BandejaExpedientes.vue?vue&type=script&lang=js"
import style0 from "./BandejaExpedientes.vue?vue&type=style&index=0&id=d760e0ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d760e0ba",
  null
  
)

export default component.exports